import AnimatedRoute from '@components/AnimatedRoute'
import { Rerouter } from '@components/Router/Router'
import { GAEventName } from '@plug-core/interfaces/googleAnalytics'
import { useGoogleAnalytics } from '@plug-core/providers/GoogleAnalyticsProvider'
import { getPageInfo } from '@plug-core/utils/getPageInfo'
import { WALLET_SETUP_ROUTES } from '@utils/walletSetupRoutes'
import React, { useEffect } from 'react'
import {
  createHashRouter,
  Outlet,
  RouteObject,
  RouterProvider,
  useLocation,
} from 'react-router-dom'
import { WalletSetupBackupSeed } from './components/BackupSeed'
import { ConnectPlug } from './components/ConnectPlug'
import { WalletSetupImportSeed } from './components/ImportSeed'
import { WalletSetupOptions } from './components/SetupOptions'
import { WalletSetupPassword } from './components/SetupPassword'
import { WalletSetupSuccess } from './components/SetupSuccess'

export const WALLET_SETUP_ROUTE_DATA: RouteObject[] = [
  {
    path: WALLET_SETUP_ROUTES.WALLET_SETUP,
    element: (
      <AnimatedRoute animationDirection="base" navbar={false}>
        <WalletSetupOptions />
      </AnimatedRoute>
    ),
    index: true,
  },
  {
    path: WALLET_SETUP_ROUTES.PASSWORD,
    element: (
      <AnimatedRoute animationDirection="right" navbar={false}>
        <WalletSetupPassword />
      </AnimatedRoute>
    ),
  },
  {
    path: WALLET_SETUP_ROUTES.IMPORT_SEED,
    element: (
      <AnimatedRoute animationDirection="right" navbar={false}>
        <WalletSetupImportSeed />
      </AnimatedRoute>
    ),
  },
  {
    path: WALLET_SETUP_ROUTES.BACKUP_SEED,
    element: (
      <AnimatedRoute animationDirection="right" navbar={false}>
        <WalletSetupBackupSeed />
      </AnimatedRoute>
    ),
  },
  {
    path: WALLET_SETUP_ROUTES.CONNECT_PLUG,
    element: (
      <AnimatedRoute animationDirection="right" navbar={false}>
        <ConnectPlug />
      </AnimatedRoute>
    ),
  },
  {
    path: WALLET_SETUP_ROUTES.SUCCESS,
    element: (
      <AnimatedRoute animationDirection="right" navbar={false}>
        <WalletSetupSuccess />
      </AnimatedRoute>
    ),
  },
]

const RootLayot = () => {
  const { fireEvent } = useGoogleAnalytics()
  const { pathname } = useLocation()

  useEffect(() => {
    fireEvent(GAEventName.PAGE_VIEW, getPageInfo(WALLET_SETUP_ROUTES, pathname))
  }, [pathname])

  return <Outlet />
}

const router = createHashRouter([
  {
    element: <RootLayot />,
    children: WALLET_SETUP_ROUTE_DATA,
    errorElement: <Rerouter root={WALLET_SETUP_ROUTES.WALLET_SETUP} />,
  },
])

/**
 * Setup flow frame. Each step owns the viewport itself (the welcome page via `.welcome`, the
 * other steps via `SetupStep`), so the frame only provides a full-height column; the tone's
 * background art comes from `html`.
 */
export const WalletSetup = () => {
  return (
    <div className="flex h-dvh w-full flex-col overflow-hidden text-fg">
      <RouterProvider router={router} />
    </div>
  )
}

export {
  WalletSetupBackupSeed,
  WalletSetupImportSeed,
  WalletSetupOptions,
  WalletSetupPassword,
  WalletSetupSuccess,
}
